var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.imageElement
    ? _c(
        "div",
        { staticClass: "map-style-wrapper" },
        [
          _c("label", [_vm._v("Map Styles")]),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom mb-3" }),
          _vm._v(" "),
          _setup.hasMapStyles
            ? _c(_setup.DraggableList, {
                staticClass: "draggable-wrapper mb-3",
                attrs: {
                  value: _setup.availableStyleItems,
                  "item-key": "styleId",
                  draggable: !_setup.isDisabled,
                  "hide-counter": "",
                },
                on: {
                  input: _setup.handleReorder,
                  "drag-end": _setup.handleDragEnd,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item",
                      fn: function ({ element, index }) {
                        return [
                          _c(_setup.MapStyleListItem, {
                            attrs: {
                              id: index,
                              item: element.styleId,
                              readonly:
                                _setup.isDisabled ||
                                _setup.availableStyleItems.length <= 1,
                              "is-default":
                                element.styleId ===
                                _setup.model.mapConfig?.defaultStyle,
                            },
                            on: {
                              edit: _setup.handleEditStyle,
                              remove: _setup.removeMapStyle,
                              "set-default": _setup.handleSetDefault,
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  728790268
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CustomMapStyleModal, {
            attrs: {
              value: _setup.isEditModalOpen,
              "style-id": _setup.editingStyleId,
              "edit-index": _setup.editingIndex,
            },
            on: {
              input: function ($event) {
                _setup.isEditModalOpen = $event
              },
              save: _setup.updateMapStyle,
            },
          }),
          _vm._v(" "),
          _c(_setup.MapStyleCreateModal, {
            attrs: { value: _setup.isAddModalOpen },
            on: {
              input: function ($event) {
                _setup.isAddModalOpen = $event
              },
              create: _setup.createMapStyle,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c(_setup.CButton, {
                staticClass: "w-100",
                attrs: {
                  size: "md",
                  text: "Add Map Style",
                  variant: "light",
                  icon: ["fa-solid", "fa-sparkles"],
                  disabled: _setup.isDisabled,
                },
                on: { click: _setup.openAddMapStyleModal },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "footer mt-4" }, [
      _c("div", { staticClass: "border-bottom mb-3" }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Choose one or multiple styles. Add custom or preset styles for customers to pick during personalization.\n            Learn more in the\n            "
        ),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://help.customily.com/hc/en-us/articles/16195841828891-Map",
              rel: "noopener noreferrer",
              target: "_blank",
            },
          },
          [_vm._v("docs")]
        ),
        _vm._v(".\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }